import type { PayloadAction } from '@reduxjs/toolkit'

import { createSlice } from '@reduxjs/toolkit'

interface State {
  client: {
    version: {
      ref?: string
      date?: string
    }
  }

  server: {
    version: {
      ref?: string
      date?: string
    }
  }

  loadingQueue: LoadingJob[]
}

interface LoadingJob {
  id: React.Key
  description?: string
}

let initialState: State = {
  client: {
    version: {}
  },
  server: {
    version: {}
  },
  loadingQueue: []
}

let slice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    startLoading (state, action: PayloadAction<LoadingJob>) {
      state.loadingQueue = [ ...state.loadingQueue, action.payload ]
    },

    finishLoading (state, action: PayloadAction<LoadingJob['id']>) {
      state.loadingQueue = state.loadingQueue.filter(job => job.id !== action.payload)
    },

    setClientVersion (state, action: PayloadAction<State['client']['version']>) {
      state.client.version = action.payload
    },

    setServerVersion (state, action: PayloadAction<State['server']['version']>) {
      state.server.version = action.payload
    }
  }
})

export let { startLoading, finishLoading, setClientVersion, setServerVersion } = slice.actions
export default slice.reducer
